import React, { useEffect, useState } from 'react';
import { useParams, Link, Navigate } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import { getPage } from '../services/api';
import useSeo from '../hooks/useSeo';

export default function Page() {
  const { slug } = useParams();
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setNotFound(false);
    setPage(null);

    getPage(slug)
      .then((data) => {
        if (cancelled) return;
        setPage(data);
      })
      .catch(() => {
        if (cancelled) return;
        setNotFound(true);
      })
      .finally(() => {
        if (cancelled) return;
        setLoading(false);
      });

    return () => { cancelled = true; };
  }, [slug]);

  useSeo({
    title:       page?.meta_title || page?.title,
    description: page?.meta_description || (page?.body ? page.body.replace(/<[^>]+>/g, ' ').slice(0, 160) : ''),
    type:        'article',
    canonical:   `/pages/${slug}`,
  });

  if (loading) {
    return (
      <main className="bg-white min-h-[calc(100vh-4rem)] flex items-center justify-center text-neutral-500">
        Loading...
      </main>
    );
  }

  if (notFound || !page) return <Navigate to="/" replace />;

  return (
    <main className="bg-white min-h-[calc(100vh-4rem)]">
      <section className="bg-[#1e3a2b] text-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-14 sm:py-16">
          <nav className="flex items-center gap-1.5 text-xs text-neutral-300">
            <Link to="/" className="hover:text-white">Home</Link>
            <ChevronRight className="w-3.5 h-3.5" />
            <span className="text-white">{page.title}</span>
          </nav>
          <h1 className="mt-3 font-serif text-4xl sm:text-5xl">{page.title}</h1>
          {page.hero && <p className="mt-3 text-neutral-200 max-w-2xl">{page.hero}</p>}
        </div>
      </section>

      <article
        className="cms-content max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-10 sm:py-14"
        dangerouslySetInnerHTML={{ __html: page.body }}
      />
    </main>
  );
}
